import { MeasuringTypeInfo, MeasuringUnit, MeasuringUnitInfo, MeasuringUnitInfoMap } from '@/types';

export function calculateBaseAmount(
    amount: number,
    unit: MeasuringUnit,
    unitMap: MeasuringUnitInfoMap
): {
    amount: number;
    unitInfo: MeasuringUnitInfo;
    typeInfo?: MeasuringTypeInfo;
} {
    // Find the type group that contains the given measuring unit
    const type = Object.values(unitMap).find(
        (typeInfo) => typeInfo.units.some((unitInfo) => unitInfo.unit === unit)
    );

    const currentUnitInfo = type?.units.find((unitInfo) => unitInfo.unit === unit);

    if (!type || !currentUnitInfo) {
        return { amount, unitInfo: { unit, multiplier: 1 } };
    }

    const baseUnit = type.units.find(u => u.multiplier === 1) || [...type.units].sort((a, b) => a.multiplier - b.multiplier)[0];

    return {
        amount: (amount * currentUnitInfo.multiplier) / baseUnit.multiplier,
        unitInfo: baseUnit,
        typeInfo: type
    };
}

export function calculateMaximalUnit(
    quantity: number,
    unit: MeasuringUnit,
    unitMap: MeasuringUnitInfoMap
): {
    amount: number;
    unit: MeasuringUnit;
} {
    const {
        amount: baseAmount,
        unitInfo: baseUnit,
        typeInfo
    } = calculateBaseAmount(quantity, unit, unitMap);

    let maxUnit = typeInfo?.units
        ? [...typeInfo.units]
            .sort((a, b) => a.multiplier - b.multiplier)
            .filter((u) => (u.multiplier / (baseUnit?.multiplier || 1)) <= baseAmount)
            .pop()
        : undefined;

    if (!maxUnit || !baseUnit) {
        return { amount: quantity, unit };
    }

    return {
        amount: baseAmount / (maxUnit.multiplier / baseUnit.multiplier),
        unit: maxUnit.unit
    };
}
